
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/comparison",
      function () {
        return require("private-next-pages/programs/comparison/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/comparison"])
      });
    }
  